export const IconStoreFilled = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconStoreFilled_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconStoreFilled_svg__a)">
        <path d="M5.025 21q-.825 0-1.412-.587A1.93 1.93 0 0 1 3.025 19v-7.95q-.575-.525-.887-1.35t-.013-1.8l1.05-3.4a2.2 2.2 0 0 1 .713-1.075A1.8 1.8 0 0 1 5.075 3h13.9q.675 0 1.175.413.5.412.725 1.087l1.05 3.4q.3.975-.012 1.775a3.95 3.95 0 0 1-.888 1.375V19q0 .824-.587 1.413a1.93 1.93 0 0 1-1.413.587zm9.2-11q.675 0 1.025-.463.35-.462.275-1.037l-.55-3.5h-1.95v3.7q0 .525.35.913.35.387.85.387m-4.5 0q.575 0 .938-.387.362-.388.362-.913V5h-1.95l-.55 3.5q-.101.6.263 1.05.362.45.937.45m-4.45 0q.45 0 .788-.325.337-.326.412-.825L7.025 5h-1.95l-1 3.35q-.15.5.163 1.075Q4.55 10 5.275 10m13.5 0q.724 0 1.05-.575.325-.575.15-1.075L18.925 5h-1.9l.55 3.85q.075.5.413.825a1.1 1.1 0 0 0 .787.325" />
      </g>
    </svg>
  );
};
